import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './facebookPixel';

/**
 * Componente que rastreia mudanças de rota para o Facebook Pixel
 * Não renderiza conteúdo visual, apenas monitora mudanças de URL
 */
const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Extrai informações da URL para rastreamento
    const pathSegments = location.pathname.split('/');
    const pageName = pathSegments[1] || 'home';
    
    // Informações adicionais relevantes para análise
    const fullPath = location.pathname;
    // const hasQueryParams = location.search.length > 0;
    
    // Rastrear mudança de página com o método central
    if (window.fbq) {
      trackPageView(pageName);
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`[RouteTracker] Página rastreada: ${fullPath}`);
    }
  }, [location]);

  // Este componente não renderiza nada visualmente
  return null;
};

export default RouteTracker; 